module.exports = __webpack_public_path__ + "img/loading.bc8a75bc.png";